import React from 'react';
import './Footer.css';

import Uil from './uil';
import Tmea from './tmea';

const date = new Date();
const currentYear = date.getFullYear();

const Footer = () => (
  <section className="footer">
    <div className="main_footer">
      <div className="contact_us">
        <p>Connect with us!</p>
        <div className="footer_left">
          <div className="logo_cont container0">
            <a
              href="https://www.uiltexas.org/music"
              aria-label="UIL"
              target="blank"
            >
              <Uil />
            </a>
          </div>
          <div className="logo_cont container1">
            <a href="https://www.tmea.org/" aria-label="TMEA" target="blank">
              <Tmea />
            </a>
          </div>
          <div className="logo_cont container2">
            <a
              href="https://twitter.com/TMEA"
              aria-label="Twitter"
              target="blank"
            >
              <svg className="logo logo2" viewBox="0 0 128 128">
                <path
                  id="original"
                  d="M40.58,115.3c47.64,0,73.69-39.47,73.69-73.69,0-1.12,0-2.24-.07-3.35a52.7,52.7,0,0,0,12.92-13.41,51.7,51.7,0,0,1-14.87,4.08A26,26,0,0,0,123.63,14.6a51.9,51.9,0,0,1-16.45,6.29A25.92,25.92,0,0,0,63.05,44.51,73.53,73.53,0,0,1,9.67,17.45a25.92,25.92,0,0,0,8,34.58A25.71,25.71,0,0,1,6,48.78c0,.11,0,.22,0,.33A25.91,25.91,0,0,0,26.73,74.5a25.86,25.86,0,0,1-11.7.44,25.93,25.93,0,0,0,24.2,18A52,52,0,0,1,7.06,104a52.72,52.72,0,0,1-6.18-.36,73.32,73.32,0,0,0,39.7,11.63"
                  transform="translate(-0.88 -12.7)"
                />
              </svg>
            </a>
          </div>
        </div>
        <p>www.region20music.com</p>
      </div>
      <div className="footer_right">
        <p className="copyright">© {currentYear} Olive Branch Designs</p>
        <img
          className="olive"
          src="https://res.cloudinary.com/dwvrok1le/image/upload/v1547328733/olive-branch.png"
          alt=""
        />
      </div>
    </div>
  </section>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js